var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInprogressCircle = function SvgInprogressCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF80",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AD6C00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 6.66c.595 0 1.08-.485 1.08-1.08 0-.595-.485-1.08-1.08-1.08-.595 0-1.08.485-1.08 1.08 0 .595.485 1.08 1.08 1.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AD6C00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.394 11.5c.595 0 1.08-.485 1.08-1.08 0-.595-.485-1.08-1.08-1.08-.595 0-1.08.485-1.08 1.08 0 .595.48 1.08 1.08 1.08Z",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AD6C00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.605 11.5c.595 0 1.08-.485 1.08-1.08 0-.595-.485-1.08-1.08-1.08-.595 0-1.08.485-1.08 1.08 0 .595.485 1.08 1.08 1.08Z"
  })));
};
export default SvgInprogressCircle;